import { customAlphabet } from 'nanoid/non-secure';

export const nanoid = customAlphabet('1234567890abcdef', 16);
export const getB3 = (): string => `${nanoid()}`;
